



//请求往期列表列表
export const PAST_REQ = 'PAST_REQ'

//处理往期列表列表
export const PAST_HANDLE = 'PAST_HANDLE'



//处理领取任务
export const PAST_HANDLE_TASK = 'PAST_HANDLE_TASK'